import React, { useEffect, useState } from "react";

import {
  FaChevronDown,
  FaHome,
  FaHotel,
  FaBed,
  FaUserTie,


} from "react-icons/fa";
import { FaPeopleGroup, FaUserGroup } from "react-icons/fa6";

import { CiViewList } from "react-icons/ci";
import { LuTicketsPlane } from "react-icons/lu";
import { TbFerry } from "react-icons/tb";
import { GiWorld } from "react-icons/gi";
import { IoCarSport } from "react-icons/io5";
import { RxActivityLog } from "react-icons/rx";
import { MdLeaderboard } from "react-icons/md";
import { SiExpensify } from "react-icons/si";

import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import logo from "../../assets/logo-white.png";
import smalllogo from "../../assets/yellow-logo.png";

export default function SideNav({ open, toggle }) {
  const { profile } = useSelector((state) => state.auth);
  // Identify logged-in staff
  const isStaff =
    profile?.userType === "STAFF" ||
    profile?.role === "STAFF";

  // Check module permissions
  const hasPermission = (module) => {
    // Admin has full access
    if (!isStaff) return true;

    const permission = profile?.permissions?.[module];

    const levels = Array.isArray(permission)
      ? permission
      : [permission];

    return levels.some((level) =>
      ["VIEW", "EDIT", "FULL"].includes(
        String(level || "").toUpperCase()
      )
    );
  };

  const location = useLocation();

  const [openHotel, setOpenHotel] = useState(false);
  const [openPackages, setOpenPackages] = useState(false);

  const organizationLogo = profile?.organization?.logo;


  /* =====================================================
     CURRENT ROUTE
  ===================================================== */

  const hotelActive =
    location.pathname.includes("/admin/hotels") ||
    location.pathname.includes("/admin/roomtype") ||
    location.pathname.includes("/admin/hotel-rooms") ||
    location.pathname.includes("/admin/addroom-type") ||
    location.pathname.includes("/admin/editroom-type");


  const packageActive =
    location.pathname.includes("/admin/category") ||
    location.pathname.includes("/admin/packages");

  useEffect(() => {
    if (hotelActive) {
      setOpenHotel(true);
    }

    if (packageActive) {
      setOpenPackages(true);
    }
  }, [hotelActive, packageActive]);



  useEffect(() => {
    if (!open) {
      setOpenHotel(false);
      setOpenPackages(false);
    }
  }, [open]);



  const handleHotelToggle = () => {
    if (!open) {
      // First expand sidebar
      toggle();

      // Then open hotel submenu
      setOpenHotel(true);

      // Close other submenu
      setOpenPackages(false);

      return;
    }

    // Sidebar already expanded
    setOpenHotel((prev) => !prev);

    // Close other submenu
    setOpenPackages(false);
  };


  const handlePackageToggle = () => {
    if (!open) {
      // First expand sidebar
      toggle();

      // Then open package submenu
      setOpenPackages(true);

      // Close other submenu
      setOpenHotel(false);

      return;
    }

    // Sidebar already expanded
    setOpenPackages((prev) => !prev);

    // Close other submenu
    setOpenHotel(false);
  };



  return (
    <>
      {/* Mobile overlay */}
      {open && (
        <div
          className="sidebar-overlay"
          onClick={toggle}
          aria-hidden="true"
        />
      )}

      <aside className={`sidenav ${open ? "open" : "collapsed"}`}>

        {/* =================================================
          LOGO
      ================================================= */}

        <div className="sidenav-header">

          <div className="sidenav-logo-wrapper">

            <img
              src={
                organizationLogo
                  ? organizationLogo
                  : open
                    ? logo
                    : smalllogo
              }
              alt="Logo"
              className="sidenav-logo"
            />

          </div>

        </div>


        {/* =================================================
          MENU
      ================================================= */}

        <div className="sidenav-menu">

          <ul className="menu">


            {/* =================================================
              DASHBOARD
          ================================================= */}

            <li>
              <NavLink
                to="/admin/home"
                end
                data-label="Dashboard"
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
              >

                <span className="menu-icon">
                  <FaHome size={19} />
                </span>

                <span className="text">
                  Dashboard
                </span>

              </NavLink>
            </li>


            {/* =================================================
              SERVICE PROVIDERS
          ================================================= */}


            {!isStaff && (<li>
              <NavLink
                to="/admin/vendor"
                data-label="Service Providers"
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
              >

                <span className="menu-icon">
                  <FaPeopleGroup size={19} />
                </span>

                <span className="text">
                  Service Providers
                </span>

              </NavLink>
            </li>

            )}
            {/* =================================================
              AGENTS
          ================================================= */}


            {!isStaff && (<li>
              <NavLink
                to="/admin/agent"
                data-label="Agents"
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
              >

                <span className="menu-icon">
                  <FaUserGroup size={19} />
                </span>

                <span className="text">
                  Agents
                </span>

              </NavLink>
            </li>)}


            {/* =================================================
              PLACES
          ================================================= */}


            {!isStaff && (<li>
              <NavLink
                to="/admin/places"
                data-label="Places"
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
              >

                <span className="menu-icon">
                  <GiWorld size={19} />
                </span>

                <span className="text">
                  Places
                </span>

              </NavLink>
            </li>)}


            {/* =================================================
              HOTELS
          ================================================= */}

            <li className="menu-parent-item">

              <div
                className={`menu-parent ${hotelActive ? "active-parent" : ""
                  }`}
                data-label="Hotels"
                onClick={handleHotelToggle}
              >

                <span className="menu-icon">
                  <FaHotel size={19} />
                </span>

                <span className="text">
                  Hotels
                </span>

                {open && (
                  <span
                    className={`submenu-arrow ${openHotel ? "rotate" : ""
                      }`}
                  >
                    <FaChevronDown size={13} />
                  </span>
                )}

              </div>


              {/* HOTEL SUBMENU */}

              <ul
                className={`submenu ${openHotel ? "submenu-open" : ""
                  }`}
              >

                <li>
                  <NavLink
                    to="/admin/hotels"
                    className={({ isActive }) =>
                      isActive ? "active" : ""
                    }
                  >

                    <span className="submenu-icon">
                      <FaHotel size={13} />
                    </span>

                    <span className="text">
                      Hotels
                    </span>

                  </NavLink>
                </li>


                <li>
                  <NavLink
                    to="/admin/roomtype"
                    className={({ isActive }) =>
                      isActive ? "active" : ""
                    }
                  >

                    <span className="submenu-icon">
                      <FaBed size={13} />
                    </span>

                    <span className="text">
                      Rooms
                    </span>

                  </NavLink>
                </li>

              </ul>

            </li>


            {/* =================================================
              FERRY
          ================================================= */}

            <li>
              <NavLink
                to="/admin/ferry"
                data-label="Ferry"
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
              >

                <span className="menu-icon">
                  <TbFerry size={20} />
                </span>

                <span className="text">
                  Ferry
                </span>

              </NavLink>
            </li>


            {/* =================================================
              ACTIVITIES
          ================================================= */}

            <li>
              <NavLink
                to="/admin/activity"
                data-label="Activities"
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
              >

                <span className="menu-icon">
                  <RxActivityLog size={19} />
                </span>

                <span className="text">
                  Activities
                </span>

              </NavLink>
            </li>


            {/* =================================================
              VEHICLES
          ================================================= */}

            <li>
              <NavLink
                to="/admin/vehicle"
                data-label="Vehicles"
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
              >

                <span className="menu-icon">
                  <IoCarSport size={20} />
                </span>

                <span className="text">
                  Vehicles
                </span>

              </NavLink>
            </li>


            {/* =================================================
              PACKAGES
          ================================================= */}

            <li className="menu-parent-item">

              <div
                className={`menu-parent ${packageActive ? "active-parent" : ""
                  }`}
                data-label="Packages"
                onClick={handlePackageToggle}
              >

                <span className="menu-icon">
                  <LuTicketsPlane size={20} />
                </span>

                <span className="text">
                  Packages
                </span>

                {open && (
                  <span
                    className={`submenu-arrow ${openPackages ? "rotate" : ""
                      }`}
                  >
                    <FaChevronDown size={13} />
                  </span>
                )}

              </div>


              {/* PACKAGE SUBMENU */}

              <ul
                className={`submenu ${openPackages ? "submenu-open" : ""
                  }`}
              >

                <li>
                  <NavLink
                    to="/admin/category"
                    className={({ isActive }) =>
                      isActive ? "active" : ""
                    }
                  >

                    <span className="submenu-icon">
                      <CiViewList size={15} />
                    </span>

                    <span className="text">
                      Category
                    </span>

                  </NavLink>
                </li>


                <li>
                  <NavLink
                    to="/admin/packages"
                    className={({ isActive }) =>
                      isActive ? "active" : ""
                    }
                  >

                    <span className="submenu-icon">
                      <LuTicketsPlane size={15} />
                    </span>

                    <span className="text">
                      Packages
                    </span>

                  </NavLink>
                </li>

              </ul>

            </li>


            {/* =================================================
              LEADS
          ================================================= */}

            <li>
              <NavLink
                to="/admin/lead"
                data-label="Leads"
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
              >

                <span className="menu-icon">
                  <MdLeaderboard size={20} />
                </span>

                <span className="text">
                  Leads
                </span>

              </NavLink>
            </li>


            {/* =================================================
              BOOKINGS
          ================================================= */}

            <li>
              <NavLink
                to="/admin/booking"
                data-label="Bookings"
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
              >

                <span className="menu-icon">
                  <CiViewList size={20} />
                </span>

                <span className="text">
                  Bookings
                </span>

              </NavLink>
            </li>


            {/* =================================================
              STAFF
          ================================================= */}

            {/* STAFF - ADMIN ONLY */}

            {!isStaff && (
              <li>
                <NavLink
                  to="/admin/staff"
                  data-label="Staff"
                  className={({ isActive }) =>
                    `menu-link ${isActive ? "active" : ""}`
                  }
                >
                  <span className="menu-icon">
                    <FaUserTie size={19} />
                  </span>

                  <span className="text">
                    Staff
                  </span>
                </NavLink>
              </li>
            )}


            {/* =================================================
              EXPENSE
          ================================================= */}

            <li>
              <NavLink
                to="/admin/expense"
                data-label="Expense"
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
              >

                <span className="menu-icon">
                  <SiExpensify size={19} />
                </span>

                <span className="text">
                  Expense
                </span>

              </NavLink>
            </li>


          </ul>

        </div>

      </aside>
    </>
  );
}